export const isUndefined = (value: string) => {
    return value === undefined || value === null || value === 'undefined' || value === 'null';
}